export const HALL_RETURN_ROUTE_KEY = "anokina_hall_return_route";
export const HALL_FALLBACK_ROUTE = "/hall";

const PLATFORM_ROUTE_PREFIXES = [
  "/hall",
  "/account",
  "/admin",
  "/architect",
  "/book",
  "/brand-studio",
  "/master-order",
  "/media-studio",
  "/products",
  "/projects",
];

const matchesPrefix = (pathname, prefix) =>
  pathname === prefix || pathname.startsWith(`${prefix}/`);

export function normalizeHallReturnRoute(candidate) {
  if (typeof candidate !== "string" || !candidate.startsWith("/") || candidate.startsWith("//")) {
    return null;
  }
  try {
    const parsed = new URL(candidate, "https://anokina.studio");
    if (parsed.origin !== "https://anokina.studio") return null;
    if (!PLATFORM_ROUTE_PREFIXES.some((prefix) => matchesPrefix(parsed.pathname, prefix))) return null;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return null;
  }
}

export function rememberHallReturnRoute(location, storage) {
  const candidate = normalizeHallReturnRoute(
    `${location?.pathname || ""}${location?.search || ""}${location?.hash || ""}`,
  );
  if (!candidate) return null;
  try { storage?.setItem(HALL_RETURN_ROUTE_KEY, candidate); } catch { /* storage can be unavailable */ }
  return candidate;
}

export function resolveHallReturnRoute({ state, storage, fallback = HALL_FALLBACK_ROUTE } = {}) {
  const stateRoute = normalizeHallReturnRoute(state?.from);
  if (stateRoute) return stateRoute;
  try {
    const storedRoute = normalizeHallReturnRoute(storage?.getItem(HALL_RETURN_ROUTE_KEY));
    if (storedRoute) return storedRoute;
  } catch { /* storage can be unavailable */ }
  return normalizeHallReturnRoute(fallback) || HALL_FALLBACK_ROUTE;
}

